module.exports = __webpack_public_path__ + "img/5.0fc6f8b8.jpg";